import React from 'react';
import {
  HelpLink, Stack, Text, useTranslation,
} from '@piwikpro/ui-components';

export const Reset2faModal = () => {
  const { t } = useTranslation();

  return (
    <Stack vertical horizontalAlignment="middle">
      <Stack.Item fill>
        <Stack vertical spacing="narrow">
          <Stack.Item>
            <Text as="p">{t('administration:users.security.reset2fa.modal.message')}</Text>
          </Stack.Item>
          <Stack.Item>
            <Text as="p">{t('administration:users.security.reset2fa.modal.question')}</Text>
          </Stack.Item>
        </Stack>
      </Stack.Item>
      <Stack.Item>
        <HelpLink href="https://help.piwik.pro/support/account/two-factor-authentication/">
          Set up two-factor authentication (2FA)
        </HelpLink>
      </Stack.Item>
    </Stack>
  );
};
